<template>
  <div id="app">
    <!-- <button @click="handleChange">切换</button> -->
    <div class="control-img">
      <img
        @click="handleChange"
        :src="
          direction == 'portrait'
            ? require('../../assets/image/magnify-icons.png')
            : require('../../assets/image/shrink-icons.png')
        "
        alt=""
      />
    </div>
    <div></div>
    <div class="charts-counter">
      <div id="flowLine"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      directionObj: {
        portrait: "portrait",
        landscape: "landscape",
      },
      direction: "portrait",
      myChart: null,
      chartData: [],
      setIntervalTimer: null,
    };
  },
  watch: {
    direction(newValue) {
      const appDom = document.getElementById("app");
      if (newValue === this.directionObj.portrait) {
        appDom.classList.remove(this.directionObj.landscape);
        appDom.classList.add(this.directionObj.portrait);
      } else {
        appDom.classList.remove(this.directionObj.portrait);
        appDom.classList.add(this.directionObj.landscape);
      }
    },
  },
  async mounted() {
    await this.getChartsData();
    this.$nextTick(() => {
      this.getFlowLineECharts();
    });
    this.setIntervalTimer = setInterval(async () => {
      await this.getChartsData();
      this.$nextTick(() => {
        this.getFlowLineECharts();
      });
    }, 60000);
  },
  destroyed() {
    clearInterval(this.setIntervalTimer);
  },
  methods: {
    async getChartsData() {
      const { data: res } = await this.$authAjax.post(
        "/api/report/kordar/screen2/data",
        {
          token: "5531d2146d254cc494d146e9638fb3f9",
          includes: ["flow"],
          widgetType: "widget-linechart",
          items: [
            {
              id: "flow",
              keyName: "data",
              format: "",
              type: "ksInOutFlow",
              params: {},
            },
          ],
        }
      );
      this.chartData = res.data.data;
    },
    handleChange() {
      this.direction =
        this.direction === this.directionObj.portrait
          ? this.directionObj.landscape
          : this.directionObj.portrait;
      this.$nextTick(() => {
        setTimeout(() => {
          this.resizeChart();
        }, 300);
      });
    },
    resizeChart() {
      if (this.myChart) {
        this.myChart.resize();
      }
    },
    getFlowLineECharts() {
      this.myChart = this.$echarts.init(document.getElementById("flowLine"));

      const xAxis = this.chartData?.map((item) => item.key); // 时间点升序排列

      const inData = this.chartData?.map((item) => item.value);
      // const outData = xAxis.map((time) => outMap.get(time) ?? 0);

      let option = {
        legend: {
          // data: ["进", "出"],
        },
        xAxis: {
          type: "category",
          data: xAxis,
          name: "时间",
          nameTextStyle: {
            fontSize: 10,
          },
        },
        yAxis: {
          type: "value",
          name: "人",
          max: function (value) {
            if (value.max === 0) return 4;
            return value.max + Math.ceil(value.max * 0.1); // 多留 10% 空间
          },
        },
        series: [
          {
            data: inData,
            type: "line",
            smooth: true,
            // name: "进",
          },
          // {
          //   data: outData,
          //   type: "line",
          //   smooth: true,
          //   name: "出",
          // },
        ],
      };
      option && this.myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss">
#app {
  transition: all 0.3s ease;
  padding: 6px;
  box-sizing: border-box;
}

.portrait {
  width: 100vw;
  height: 100vh;
  position: static;
  transform: none;
  background: #fff;
}

.landscape {
  width: 100vh;
  height: 100vw;
  position: absolute;
  top: calc((100vh - 100vw) / 2);
  left: calc(-1 * (100vh - 100vw) / 2);
  transform: rotate(90deg);
  transform-origin: 50% 50%;
  background: #fff;
}

.crowd-flow-counter {
  height: 200px;
  width: 100%;
  background: lightblue;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}
// .charts-counter {
//   background: #0e1739;
//   border-radius: 10px;
// }
#flowLine {
  width: 100%;
  height: 320px;
}

.control-img {
  display: flex;
  justify-content: flex-end;
  img {
    width: 24px;
    height: 24px;
  }
}
</style>
